module.exports = {
  courier: {
    id: 6,
    caption: "Курьер",
    description: "Услуги по доставке заказов потребителям",
    rates: [325, 236, 120],
  },
  driver: {
    id: 5,
    caption: "Водитель-курьер",
    description:
      "Услуги по доставке заказов потребителям с использованием автотранспорта",
    rates: [325, 236, 120],
  },
  cargo: {
    id: 2,
    caption: "Грузчик",
    description: "Услуги по погрузке-выгрузке товаров",
    rates: [277, 250, 181],
  },
  salesroom: {
    id: 11,
    caption: "Работник торгового зала",
    description: "Услуги по выкладке и размещению товара",
    rates: [269, 254, 201],
  },
  cook: {
    id: 15,
    caption: "Повар",
    description: "Услуги по изготовлению блюд",
    rates: [247, 223, 201],
  },
  baker: {
    id: 16,
    caption: "Пекарь",
    description: "Услуги по изготовлению хлебобулочных/кондитерских изделий",
    rates: null,
  },
  molder: {
    id: 12,
    caption: "Формовщик",
    description:
      "Услуги по заполнению форм для выпечки хлебо-булочных изделий, упаковке и маркировке готовой продукции",
    rates: null,
  },
  washer: {
    id: 10,
    caption: "Мойщик",
    description: "Услуги клининга и мытья посуды",
    rates: [190, 164, 150],
  },
  cleaner: {
    id: 7,
    caption: "Уборщик",
    description:
      "Оказание услуг по уборке внутри зала и прилегающей территории",
    rates: [190, 164, 150],
  },
  merch: {
    id: 3,
    caption: "Мерчандайзер",
    description: "Услуги мерчендайзинга",
    rates: [234, 200, 171],
  },
  waiter: {
    id: 8,
    caption: "Официант",
    description:
      "Услуги по обслуживанию посетителей заведения общественного питания",
    rates: [329, 294, 235],
  },
  barista: {
    id: 9,
    caption: "Бариста",
    description: "Услуги по приготовлению безалкогольных напитков",
    rates: [231, 211, 176],
  },
  promo: {
    id: 4,
    caption: "Промоутер",
    description:
      "Услуги по презентации товаров неограниченному кругу лиц (раздача сэмплов, дегустация, раздача листовок)",
    rates: null,
  },
  cash: {
    id: 1,
    caption: "Кассир",
    description:
      "Услуги по обслуживанию посетителей в кассовой и прикассовой зоне",
    rates: [230, 217, 201],
  },
  revisor: {
    id: 20,
    caption: "Счётчик-ревизор",
    description: "Услуги по пересчету и сканированию товаров",
    rates: null,
  },
  designer: {
    id: 21,
    caption: "Дизайнер",
    description: "Услуги по разработке графических материалов",
    rates: null,
  },
  copywriter: {
    id: 22,
    caption: "Копирайтер",
    description: "Услуги копирайтинга",
    rates: null,
  },
  marketologist: {
    id: 23,
    caption: "Маркетолог",
    description: "Услуги маркетинга",
    rates: null,
  },
  analyst: {
    id: 24,
    caption: "Аналитик",
    description: "Услуги по анализу данных",
    rates: null,
  },
  contentman: {
    id: 25,
    caption: "Оператор БД",
    description: "Услуги по внесению и редактированию данных",
    rates: null,
  },
  picker: {
    id: 26,
    caption: "Комплектовщик",
    description: "Услуги по комплектации заказов",
    rates: null,
  },
  order_picker: {
    id: 27,
    caption: "Сборщик заказов",
    description: "Услуги по сборке заказов",
    rates: null,
  },
  bike_courier: {
    id: 28,
    caption: "Велокурьер",
    description:
      "Услуги по доставке заказов потребителям с использованием велотранспорта",
    rates: null,
  },
  stockman: {
    id: 29,
    caption: "Кладовщик",
    description: "Услуги по распределению товара на складе",
    rates: null,
  },
  handyman: {
    id: 30,
    caption: "Разнорабочий",
    description: "Хозяйственные работы на кухне",
    rates: null,
  },
  procurer: {
    id: 31,
    caption: "Корневщик",
    description: "Услуги по очистке овощей",
    rates: null,
  },
  confectioner: {
    id: 32,
    caption: "Кондитер",
    description: "Услуги по производству кондитерских изделий",
    rates: null,
  },
  shop_assistant: {
    id: 33,
    caption: "Продавец-консультант",
    description: "Услуги по консультированию покупателей в торговом зале",
    rates: null,
  },
  barman: {
    id: 34,
    caption: "Бармен",
    description: "Услуги бармена (приготовление напитков)",
    rates: null,
  },
  scooter_courier: {
    id: 35,
    caption: "Курьер на самокате",
    description:
      "Услуги по доставке заказов потребителям с использованием самоката",
    rates: null,
  },
  sushi_chef: {
    id: 36,
    caption: "Суши-повар",
    description: "Услуги приготовления суши",
    rates: null,
  },
  security: {
    id: 37,
    caption: "Охранник",
    description: "Услуги охраны",
    rates: null,
  },
  auxiliary_worker: {
    id: 38,
    caption: "Подсобный рабочий",
    description:
      "Оказание услуг, не требующих специальной подготовки (выполнение подсобных работ)",
    rates: null,
  },
  servicemaster: {
    id: 39,
    caption: "Мастер сервиса",
    description: "Сборка велосипедов",
    rates: null,
  },
  salesroom_custom: {
    id: 40,
    caption: "Работник зала (спорттовары)",
    description: "Раскладка товара в торговых залах магазинов",
    rates: null,
  },
  stockman_custom: {
    id: 41,
    caption: "Сортировщик на склад",
    description: "Раскладка товара на складах объектов",
    rates: null,
  },
  cargo_custom: {
    id: 42,
    caption: "Грузчик (спорттовары)",
    description: "Погрузка-разгрузка на объектах",
    rates: null,
  },
  bike_assembler: {
    id: 43,
    caption: "Сборщик велосипедов",
    description:
      "Настройка велосипедов, участие в конвейерной сборке велосипедов и другие дополнительные работы, связанные со сборкой",
    rates: null,
  },
  order_picker_custom: {
    id: 44,
    caption: "Сборщик заказов (спорттовары)",
    description:
      "Приём и сбор заказов интернет-магазина, раскладка собранных заказов по ячейкам",
    rates: null,
  },
  packer: {
    id: 45,
    caption: "Упаковщик",
    description:
      "Упаковка и возврат невыкупленных заказов/товаров на распределительный центр",
    rates: null,
  },
  flat_assistant: {
    id: 46,
    caption: "Квартирный ассистент для показа жилья",
    description: "Услуги по обеспечению показа квартир",
    rates: null,
  },
  scout: {
    id: 47,
    caption: "Скаут",
    description:
      "Услуги по проверке местонахождения, размещению в обозначенных парковочных зонах, проведению внешней диагностики электросамокатов",
    rates: null,
  },
  charger_scooter: {
    id: 48,
    caption: "Чарджер на самокате",
    description:
      "Услуги по доставке заряженных аккумуляторов электросамокатов в обозначенную зону, замена аккумулятора (на самокате)",
    rates: null,
  },
  charger_auto: {
    id: 49,
    caption: "Чарджер на легковом автомобиле",
    description:
      "Услуги по доставке заряженных аккумуляторов электросамокатов в обозначенную зону, замена аккумуляторов (на автомобиле)",
    rates: null,
  },
  technician: {
    id: 50,
    caption: "Техник",
    description:
      "Услуги по проведению внутренней диагностики неисправностей, осуществлению ремонтных работ и сборке электросамокатов",
    rates: null,
  },
  scooter_engineer: {
    id: 51,
    caption: "Инженер",
    description:
      "Услуги демонтажа, сборки узлов и блоков, проведению комплекса ремонтных работ, анализа причин неисправностей электросамокатов\n",
    rates: null,
  },
  scooter_carrier: {
    id: 52,
    caption: "Водитель на легковом автомобиле",
    description:
      "Услуги по транспортировке заряженных электросамокатов в обозначенную зону и доставке разряженных/неисправных в пункты зарядки",
    rates: null,
  },
  truckman: {
    id: 53,
    caption: "Водитель на грузовом автомобиле",
    description: "Услуги по доставке грузов",
    rates: null,
  },
  scooter_acceptor: {
    id: 54,
    caption: "Мастер-приемщик",
    description:
      "Услуги по проведению диагностики на наличие неисправностей, ремонтные работы, зарядка аккумулятора электросамокатов",
    rates: null,
  },
  scooter_tester: {
    id: 55,
    caption: "Тестировщик СЦ",
    description:
      "Услуги тестирования электросамокатов на наличие неисправностей, сортировке по сложности ремонта,зарядке аккумулятора эл.самоката",
    rates: null,
  },
  coordinator: {
    id: 56,
    caption: "Координатор",
    description:
      "Услуги по организации и координации деятельности исполнителей",
    rates: null,
  },
  loader: {
    id: 57,
    caption: "Водитель погрузчика",
    description: "Услуги по погрузке-разгрузке товаров с применением специальной техники",
    rates: null,
  },
  recipient_of_goods: {
    id: 58,
    caption: "Приемщик",
    description: "Услуги по приемке товара/продукции (бытовая химия, фрэш, молочные продукты, крупы и т.д.)",
    rates: null,
  },
  cash_2: {
    id: 59,
    caption: "Продавец",
    description: "Услуги по обслуживанию покупателей в кассовых и предкассовых зонах",
    rates: null,
  },
  cash_3: {
    id: 60,
    caption: "Разнорабочий",
    description: "Услуги по сервису на линии касс",
    rates: null,
  },
  cash_4: {
    id: 61,
    caption: "Экспресс-сканировщик",
    description: "Услуги консультации на станции экспресс-сканирования",
    rates: null,
  },
  revisor_custom: {
    id: 62,
    caption: "Счётчик-ревизор",
    description: "Услуги по подсчету товаров, без ТСД, услуги по частичной инвентаризации товарных остатков",
    rates: null,
  },
  salesroom_2: {
    id: 63,
    caption: "Работник торгового зала",
    description: "Услуги по выкладке товара в торговом зале",
    rates: null,
  },
  baker_2: {
    id: 64,
    caption: "Пекарь (отдел пекарня)",
    description: "Услуги по предпродажной подготовке выпечки собственного производства",
    rates: null,
  },
  cook_assistant_1: {
    id: 65,
    caption: "Помощник повара (кулинария)",
    description: "Услуги по предпродажной подготовке блюд собственного производства",
    rates: null,
  },
  cook_assistant_2: {
    id: 66,
    caption: "Помощник повара (отдел мясо/птица)",
    description: "Услуги по предпродажной подготовке мясных блюд собственного производства",
    rates: null,
  },
  cook_assistant_3: {
    id: 67,
    caption: "Помощник повара (отдел рыба)",
    description: "Услуги по предпродажной подготовке рыбных блюд собственного производства",
    rates: null,
  },
  cook_assistant_4: {
    id: 68,
    caption: "Помощник повара (мясная гастрономия/сыр)",
    description: "Услуги по предпродажной подготовке рыбных блюд собственного производства",
    rates: null,
  },
  packer_cooking: {
    id: 69,
    caption: "Упаковщик (кулинария)",
    description: "Услуги по предпродажной фасовке выпечки и блюд собственного производства",
    rates: null,
  },
  cash_5: {
    id: 71,
    caption: "Продавец",
    description: "Услуги расчетно-кассового обслуживания",
    rates: null,
  },
  scan: {
    id: 72,
    caption: "Счётчик-ревизор",
    description: "Услуги по сканированию товаров",
    rates: null,
  },
  cargo_custom_2: {
    id: 73,
    caption: "Грузчик (логистика)",
    description: "Погрузочно-разгрузочные работы на объектах",
    rates: null,
  },
};
